/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_External_Booking_Edit_Visitor_CountInputs */

const en_admin_external_booking_edit_visitor_count = /** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`1 visitor`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} visitors`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.visitor_count");
};

const de_admin_external_booking_edit_visitor_count = /** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`1 Besucher`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Besucher`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.visitor_count");
};

const es_admin_external_booking_edit_visitor_count = /** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`1 visitante`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} visitantes`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.visitor_count");
};

const fr_admin_external_booking_edit_visitor_count = /** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`1 visiteur`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} visiteurs`);
	return /** @type {LocalizedString} */ ("admin.external_booking_edit.visitor_count");
};

/** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */
const it_admin_external_booking_edit_visitor_count = en_admin_external_booking_edit_visitor_count;

/** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_visitor_count = en_admin_external_booking_edit_visitor_count;

/** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */
const pl_admin_external_booking_edit_visitor_count = en_admin_external_booking_edit_visitor_count;

/** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */
const hu_admin_external_booking_edit_visitor_count = en_admin_external_booking_edit_visitor_count;

/** @type {(inputs: Admin_External_Booking_Edit_Visitor_CountInputs) => LocalizedString} */
const ro_admin_external_booking_edit_visitor_count = en_admin_external_booking_edit_visitor_count;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "1 visitor" |
* | "other" | "{count} visitors" |
*
* @param {Admin_External_Booking_Edit_Visitor_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_visitor_count = /** @type {((inputs: Admin_External_Booking_Edit_Visitor_CountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Visitor_CountInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_visitor_count(inputs)
	if (locale === "de") return de_admin_external_booking_edit_visitor_count(inputs)
	if (locale === "es") return es_admin_external_booking_edit_visitor_count(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_visitor_count(inputs)
	if (locale === "it") return it_admin_external_booking_edit_visitor_count(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_visitor_count(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_visitor_count(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_visitor_count(inputs)
	return ro_admin_external_booking_edit_visitor_count(inputs)
});
export { admin_external_booking_edit_visitor_count as "admin.external_booking_edit.visitor_count" }